export const SEND_MESSAGE_MODAL_TITLE_ID = "sendMessageModalTitle";
export const SEND_MESSAGE_PAGE_TITLE_ID = "sendMessagePageTitle";
